import * as React from 'react';

import { I18nextProvider } from 'react-i18next';

import i18n from '@/i18n';

interface OwnProps {
	children: React.ReactNode;
}

const AppLanguageProvider: React.FC<OwnProps> = ({ children }) => {
	return (
		<I18nextProvider i18n={i18n} defaultNS='ru'>
			{children}
		</I18nextProvider>
	);
};

export default AppLanguageProvider;
